import { api } from './api';
import { GrupoTurma, GrupoTurmaMembro, CreateTurmaDTO, UpdateTurmaDTO } from '../types/turmas';

export const turmasAPI = {
  // Listar turmas de um grupo
  listarPorGrupo: async (idGrupo: string): Promise<GrupoTurma[]> => {
    const response = await api.get(`/grupos/${idGrupo}/turmas`);
    return response.data;
  },

  // Buscar turma específica
  buscarPorId: async (id: string): Promise<GrupoTurma> => {
    const response = await api.get(`/turmas/${id}`);
    return response.data;
  },

  // Criar turma
  criar: async (data: CreateTurmaDTO): Promise<GrupoTurma> => {
    const response = await api.post(`/grupos/${data.id_grupo}/turmas`, data);
    return response.data;
  },

  // Atualizar turma
  atualizar: async (id: string, data: UpdateTurmaDTO): Promise<GrupoTurma> => {
    const response = await api.put(`/turmas/${id}`, data);
    return response.data;
  },

  // Excluir turma
  excluir: async (id: string): Promise<void> => {
    await api.delete(`/turmas/${id}`);
  },

  // Listar membros de uma turma
  listarMembros: async (idTurma: string): Promise<GrupoTurmaMembro[]> => {
    const response = await api.get(`/turmas/${idTurma}/membros`);
    return response.data;
  },

  // Adicionar membros à turma
  adicionarMembros: async (idTurma: string, idsMilitaresGrupos: string[]): Promise<GrupoTurmaMembro[]> => {
    const response = await api.post(`/turmas/${idTurma}/membros`, {
      ids_militares_grupos: idsMilitaresGrupos,
    });
    return response.data;
  },

  // Remover membros da turma
  removerMembros: async (idTurma: string, idsMilitaresGrupos: string[]): Promise<void> => {
    await api.delete(`/turmas/${idTurma}/membros`, {
      data: { ids_militares_grupos: idsMilitaresGrupos },
    });
  },
};
